// @flow
import "core-js/es6";
import "raf/polyfill";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { CookiesProvider } from "react-cookie";
// import registerServiceWorker from './registerServiceWorker';

import { injectGlobal } from "styled-components";

injectGlobal`
  @font-face {
    font-family: 'BLOKK';
    src: url('fonts/BLOKK/BLOKKNeue-Regular.eot');
    src: url('fonts/BLOKK/BLOKKNeue-Regular.eot?#iefix') format('embedded-opentype'),
         url('fonts/BLOKK/BLOKKNeue-Regular.woff2') format('woff2'),
         url('fonts/BLOKK/BLOKKNeue-Regular.woff') format('woff'),
         url('fonts/BLOKK/BLOKKNeue-Regular.otf') format('opentype'),
         url('fonts/BLOKK/BLOKKNeue-Regular.ttf') format('truetype'),
         url('fonts/BLOKK/BLOKKNeue-Regular.svg#BLOKKRegular') format('svg');
    font-weight: normal;
    font-style: normal;
}

@media screen and (-webkit-min-device-pixel-ratio:0) {
    @font-face {
        font-family: 'BLOKK';
        src: url('fonts/BLOKK/BLOKKNeue-Regular.svg') format('svg');
    }
}

body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}


  @import url("https://fonts.googleapis.com/css?family=Lato:100,100i,300,300i,400,400i,700,700i,900,900i|Neuton:200,300,400,400i,700,800|Roboto:300,400,500");
  body {
    margin: 0;
    padding: 0;
    font-family: Lato, "Microsoft Yahei", sans-serif;
    background-color: white;
  }
`;

let root = document.getElementById("root");
if (root instanceof Element) {
  ReactDOM.render(
    <Provider store={store}>
      <CookiesProvider>
        <App />
      </CookiesProvider>
    </Provider>,
    root
  );
}

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js